import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import App from './App.tsx';
import './index.css';

const rootEl = document.getElementById('root');
if (!rootEl) {
  throw new Error('Lovable theme: missing #root element');
}

const basename = rootEl.dataset.routerBasename || '/';

createRoot(rootEl).render(
  <StrictMode>
    <App basename={basename} />
  </StrictMode>,
);

// Service routes use the bundled Anandadhara application on the same origin.
document.addEventListener('click', (event) => {
  if (!(event.target instanceof Element)) return;
  const anchor = event.target.closest('a');
  if (!anchor || event.ctrlKey || event.metaKey || event.shiftKey || anchor.target === '_blank') return;
  const url = new URL(anchor.href, location.href);
  if (url.origin === location.origin && (/^\/(admin|membership|donations?|cart|registration-cart|checkout|movies|sponsors)(\/|$)/.test(url.pathname) || /^\/events\/.+/.test(url.pathname))) {
    event.preventDefault();
    event.stopImmediatePropagation();
    location.assign(url.href);
  }
}, true);
